shadow$provide[103] = function(require,module,exports) {
var require$threestrap_SLASH_src_SLASH_bootstrap_DOT_js = require("threestrap/src/bootstrap.js");
require$threestrap_SLASH_src_SLASH_bootstrap_DOT_js.Bootstrap.registerPlugin("splash", {defaults:{color:"mono", fancy:true,}, listen:["ready", "mathbox/init:init", "mathbox/progress:progress", "mathbox/destroy:destroy",], uninstall() {
  return this.destroy();
}, ready(event, three) {
  if (three.MathBox && !this.div) {
    return this.init(event, three);
  }
}, init(event, three) {
  let div;
  this.destroy();
  const {color} = this.options;
  const html = `\
<div class="mathbox-loader mathbox-splash-${color}">
  <div class="mathbox-logo">
    <div> <div></div><div></div><div></div> </div>
    <div> <div></div><div></div><div></div> </div>
  </div>
  <div class="mathbox-progress"><div></div></div>
</div>\
`;
  this.div = div = document.createElement("div");
  div.innerHTML = html;
  three.element.appendChild(div);
  const x = Math.random() * 2 - 1;
  const y = Math.random() * 2 - 1;
  const z = Math.random() * 2 - 1;
  const l = 1 / Math.sqrt(x * x + y * y + z * z);
  this.loader = div.querySelector(".mathbox-loader");
  this.bar = div.querySelector(".mathbox-progress \x3e div");
  this.gyro = div.querySelectorAll(".mathbox-logo \x3e div");
  this.transforms = ["rotateZ(22deg) rotateX(24deg) rotateY(30deg)", "rotateZ(11deg) rotateX(12deg) rotateY(15deg) scale3d(.6, .6, .6)",];
  this.random = [x * l, y * l, z * l];
  this.start = three.Time.now;
  return this.timer = null;
}, progress(event, three) {
  if (!this.div) {
    return;
  }
  const {current, total} = event;
  const visible = current < total;
  clearTimeout(this.timer);
  if (visible) {
    this.loader.classList.remove("mathbox-exit");
    this.loader.style.display = "block";
  } else {
    this.loader.classList.add("mathbox-exit");
    this.timer = setTimeout(() => {
      return this.loader.style.display = "none";
    }, 150);
  }
  const width = current < total ? Math.round(1000 * current / total) * 0.1 + "%" : "100%";
  this.bar.style.width = width;
  if (this.options.fancy) {
    const weights = this.random;
    const f = Math.max(0, Math.min(1, three.Time.now - this.start));
    const increment = function(transform, j) {
      if (j == null) {
        j = 0;
      }
      return transform.replace(/(-?[0-9.e]+)deg/g, (_, n) => +n + weights[j++] * f * three.Time.step * 60 + "deg");
    };
    return (() => {
      const result = [];
      for (let i = 0; i < this.gyro.length; i++) {
        let t;
        const el = this.gyro[i];
        this.transforms[i] = t = increment(this.transforms[i]);
        result.push(el.style.transform = el.style.WebkitTransform = t);
      }
      return result;
    })();
  }
}, destroy() {
  if (this.div != null) {
    this.div.remove();
  }
  return this.div = null;
},});

};